import React, { useEffect, useState } from "react";
import { Button, Form, Input, InputNumber, Modal, Select, Upload } from "antd";
import Swal from "sweetalert2";
import { BaseURL } from "../../constants/enum/baseURL.emum";
import curriculumService from "../../services/curriculum.service";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import OverwriteMomentBE from "../common/datePicker/overwriteMomentBE";

import moment, { Moment } from "moment";
import doc7Service from "../../services/doc7.service";

const SendDoc7 = () => {
  useEffect(() => {
    (async () => {
      await curriculumService.getAll().then((res) => {
        setCurriSelect(res.data.filter((x: any) => x.type === "tqf"));
      });
    })();
  }, []);
  const [curriSelect, setCurriSelect] = useState([]);
  const [reportDay, setrReportDay] = useState<Moment | null>(moment());

  const { Option } = Select;

  const [visible, setVisible] = useState(false);
  const handleCancel = () => {
    setVisible(false);
  };
  const [form] = Form.useForm();
  const showModal = () => {
    setVisible(true);
  };

  const normFile = (e: any) => {
    // console.log("upload file:", e);
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };
  const propsUploadDoc7 = {
    naem: "file",
    action: `${BaseURL.BASE_URL}/upload/doc7`,
    onChange: (info: any) => {
      return info;
    },
  };

  const propsUploadDoc7Send = {
    naem: "file",
    action: `${BaseURL.BASE_URL}/upload/doc7Send`,
    onChange: (info: any) => {
      return info;
    },
  };

  const onFinish = async (values: any) => {
    //   values.FileDoc7[0].response.filename
    // console.log(values);

    // console.log({
    //   fileDoc7: values.FileDoc7[0].response.filename,
    //   fileDoc7Send: values.FileDoc7Send
    //     ? values.FileDoc7Send[0].response.filename
    //     : "",
    //   year: values.year,
    //   curriCode: values.curriCode,
    //   report:
    //     reportDay == null ? moment() : reportDay.format("YYYY/MM/DD HH:mm:ss"),
    // });
    await doc7Service
      .sendDoc7({
        fileDoc7: values.FileDoc7[0].response.filename,
        fileDoc7Send: values.FileDoc7Send
          ? values.FileDoc7Send[0].response.filename
          : "",
        year: values.year,
        curriCode: values.curriCode,
        report:
          reportDay == null
            ? moment()
            : reportDay.format("YYYY/MM/DD HH:mm:ss"),
      })
      .then(() => {
        // console.log("สำเร็จ");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "บันทึกสำเร็จ",
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          handleCancel();
          window.location.reload();
        });
      })
      .catch(() => {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "หลักสูตรนี้อาจมีการส่งไฟล์ มคอ.|อชว.7 ไปแล้ว",
          showConfirmButton: false,
          timer: 1500,
        });
      });
  };

  return (
    <>
      <button className="btn btn-success ms-1" onClick={showModal}>
        <i className="bi bi-folder-plus"></i> ส่งเอกสาร
      </button>

      <Modal
        visible={visible}
        title="ส่งเอกสารผลการดำเนินการของหลักสูตร มคอ.7"
        onCancel={handleCancel}
        footer={[
          <button
            type="submit"
            className="btn btn-primary"
            onClick={form.submit}
          >
            ส่งเอกสาร
          </button>,
          <button
            type="reset"
            className="btn btn-warning ms-1"
            onClick={() => form.resetFields()}
          >
            รีเซ็ต
          </button>,

          <button
            type="button"
            className="btn btn-danger ms-1"
            onClick={handleCancel}
          >
            Close
          </button>,
        ]}
      >
        <Form
          name="dynamic_form_nest_item"
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical"
          form={form}
          initialValues={{ title: "", discription: "", url: "" }}
        >
          <Form.Item
            name={"year"}
            label="ปีการศึกษา"
            rules={[
              {
                required: true,
                message: "กรุณาระบุปีการศึกษาด้วยครับ",
              },

              { type: "number", message: "กรอกเป็นตัวเลขปีเท่านั้น" },
            ]}
          >
            <InputNumber controls={false} className="col-12" />
          </Form.Item>

          <Form.Item
            name={"curriCode"}
            label="หลักสูตร"
            rules={[
              {
                required: true,
                message: "กรุณาเลือกหลักสูตรที่ต้องการส่งก่อนครับ",
              },
            ]}
          >
            <Select
              showSearch
              placeholder="เลือกหลักสูตร"
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option!.children as unknown as string)
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            >
              {curriSelect.map((curriItem: any) => {
                return (
                  <Option
                    key={curriItem.id}
                    value={curriItem.id}
                  >{`( ${curriItem.level} ${curriItem.curriCode} ) ${curriItem.name}`}</Option>
                );
              })}
            </Select>
          </Form.Item>

          <MuiPickersUtilsProvider utils={OverwriteMomentBE} locale="th">
            <div>
              <label htmlFor="doc3" className="form-label">
                วันที่รายงาน
              </label>
              <DatePicker
                // id="doc3"
                name="doc3"
                className={`form-control`}
                format="DD/MM/YYYY"
                value={reportDay}
                onChange={(value) => {
                  console.log(value);
                  setrReportDay(value);
                }}
              />
            </div>
          </MuiPickersUtilsProvider>

          <Form.Item
            name="FileDoc7"
            label="ไฟล์ มคอ.7"
            className="mt-3"
            valuePropName="fileList"
            getValueFromEvent={normFile}
            rules={[{ required: true, message: "Upload ไฟล์ มคอ.7 ด้วยครับ!" }]}
          >
            <Upload {...propsUploadDoc7} maxCount={1}>
              <Button>Click to upload</Button>
            </Upload>
          </Form.Item>

          <Form.Item
            name="FileDoc7Send"
            label="ไฟล์บันทึกนำส่งข้อมูล มคอ.7"
            valuePropName="fileList"
            getValueFromEvent={normFile}
          >
            <Upload {...propsUploadDoc7Send} maxCount={1}>
              <Button>Click to upload</Button>
            </Upload>
          </Form.Item>
          <p className="text-muted">
            อัพโหลดได้เฉพาะไฟล์ PDF และอัพโหลดได้เพียงข้อละ 1 ไฟล์เท่านั้น
          </p>
        </Form>
      </Modal>
    </>
  );
};

export default SendDoc7;
